export default {
  // 页面标题
  'pages.ops.version.title': '版本管理',
  'pages.ops.version.subtitle': '应用 APK 发布与更新管理',

  // 应用类型
  'pages.ops.version.appType.PAD': '平板点餐App',
  'pages.ops.version.appType.APOS': '点餐机App',
  'pages.ops.version.appType.BPOS': 'B账App',

  // 表格列
  'pages.ops.version.column.appType': '所属应用',
  'pages.ops.version.column.platform': '平台',
  'pages.ops.version.column.versionName': '版本号',
  'pages.ops.version.column.versionCode': 'versionCode',
  'pages.ops.version.column.updateLog': '更新说明',
  'pages.ops.version.column.status': '状态',
  'pages.ops.version.column.publishTime': '发布时间',
  'pages.ops.version.column.createTime': '创建时间',
  'pages.ops.version.column.updateTime': '更新时间',
  'pages.ops.version.column.action': '操作',
  'pages.ops.version.column.tenant': '定向租户',
  'pages.ops.version.column.store': '定向门店',

  // 定向范围
  'pages.ops.version.scope.global': '全局',
  'pages.ops.version.scope.allStores': '全部门店',

  // 状态
  'pages.ops.version.status.published': '已发布',
  'pages.ops.version.status.unpublished': '未发布',

  // 操作
  'pages.ops.version.action.publish': '发布',
  'pages.ops.version.action.offline': '取消发布',
  'pages.ops.version.action.delete': '删除',
  'pages.ops.version.action.edit': '编辑',
  'pages.ops.version.action.download': '下载',
  'pages.ops.version.delete.confirm': '删除该版本?',
  'pages.ops.version.publish.confirm':
    '发布后符合条件的终端将收到该版本升级,确认发布?',
  'pages.ops.version.offline.confirm': '下架后终端将不再收到该版本,确认下架?',
  'pages.ops.version.msg.downloadNotPublished': '仅已发布版本支持下载',

  // 搜索
  'pages.ops.version.search.appType.all': '全部',
  'pages.ops.version.search.tenant': '租户',
  'pages.ops.version.search.tenant.placeholder': '请选择租户',
  'pages.ops.version.search.store': '门店',
  'pages.ops.version.search.store.placeholder': '请先选择租户',

  // 多选
  'pages.ops.version.select.all': '全选',
  'pages.ops.version.select.invert': '反选',

  // 定向模式
  'pages.ops.version.mode.all': '全部',
  'pages.ops.version.mode.include': '指定',
  'pages.ops.version.mode.exclude': '排除',

  // 按钮 / 新增编辑页
  'pages.ops.version.button.add': '新增版本',
  'pages.ops.version.addTitle': '新增应用版本',
  'pages.ops.version.editTitle': '编辑应用版本',
  'pages.ops.version.cancel': '取消',
  'pages.ops.version.save': '保存',

  // 卡片分组
  'pages.ops.version.card.basic': '基础信息',
  'pages.ops.version.card.target': '定向发布',
  'pages.ops.version.card.apk': 'APK 文件',

  // 表单
  'pages.ops.version.form.appType': '应用',
  'pages.ops.version.form.platform': '平台',
  'pages.ops.version.form.updateLog': '更新说明',
  'pages.ops.version.form.updateLog.placeholder': '本次更新内容',
  'pages.ops.version.form.tenantMode': '租户范围',
  'pages.ops.version.form.tenant': '定向租户',
  'pages.ops.version.form.tenant.placeholder': '不选 = 全局',
  'pages.ops.version.form.storeMode': '门店范围',
  'pages.ops.version.form.store': '定向门店',
  'pages.ops.version.form.store.placeholder': '不选 = 所选租户的全部门店',

  // 上传
  'pages.ops.version.upload.button': '选择 APK 上传',
  'pages.ops.version.upload.uploading': 'APK 上传中,请稍候…',
  'pages.ops.version.upload.success': '✓ 上传成功',
  'pages.ops.version.upload.file': '文件',
  'pages.ops.version.upload.size': '大小',
  'pages.ops.version.upload.versionName': '版本号',
  'pages.ops.version.upload.unrecognized': '(未识别)',

  // 提示消息
  'pages.ops.version.msg.uploadFailed': 'APK 上传失败,未拿到下载地址',
  'pages.ops.version.msg.parseWarning':
    'APK 已上传,但未能解析 versionCode/versionName,请确认是有效 APK',
  'pages.ops.version.msg.uploadSuccess': 'APK 上传成功',
  'pages.ops.version.msg.needApk': '请先上传 APK',
  'pages.ops.version.msg.parseFailed':
    'APK 版本信息解析失败,请重新上传有效 APK',
  'pages.ops.version.msg.createSuccess': '版本已创建,请在列表点「发布」生效',
  'pages.ops.version.msg.updateSuccess': '版本已更新',
  'pages.ops.version.msg.tenantRequired': '请选择租户',
  'pages.ops.version.msg.storeRequired': '请选择门店',
  'pages.ops.version.msg.published': '已发布',
  'pages.ops.version.msg.offlined': '已取消发布',
  'pages.ops.version.msg.deleted': '已删除',

  // 已发布锁定提示(仅前端控制:草稿/已下架可编辑删除,已发布需先下架)
  'pages.ops.version.msg.publishedNoEdit':
    '该版本已发布,不可编辑。请先「取消发布」后再修改。',
  'pages.ops.version.msg.publishedNoDelete':
    '已发布版本不可删除,请先取消发布。',
};
